export const SAVED_SEARCH_ACTION_KEYS = Object.freeze({
  saveOrEdit: 'saveOrEdit',
  savedSearches: 'savedSearches',
  saveAsNew: 'saveAsNew'
});
